let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("51ema")).then(() => parcelRequire('7TYJw'));